import React from 'react';
import './FeaturesSection.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faCapsules,
  faShieldAlt,
} from '@fortawesome/free-solid-svg-icons';

const FeaturesSection = () => {
  const features = [
    {
      icon: faCheckCircle,
      title: 'Verified Pharmacy Network',
      description: 'Every pharmacy on MyApoti is vetted for trust, authenticity, and licensing.',
    },
    {
      icon: faCapsules,
      title: 'Real-Time Drug Availability',
      description: 'See which pharmacies have your needed medications in stock, instantly.',
    },
    {
      icon: faShieldAlt,
      title: 'User Protection & Trust',
      description: 'Built-in safeguards, privacy measures, and transparency for every user.',
    },
  ];

  return (
    <section className="features-section">
      <h2 className="features-title">What MyApoti Offers</h2>
      <div className="features-grid">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <FontAwesomeIcon icon={feature.icon} className="feature-icon" />
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
